module.exports = __webpack_public_path__ + "resources/img/img-secuve-tos-01-jp.8462490aeab4c65611eea255bc8f38af.png";